/* eslint-disable react/no-danger */
import React from 'react';
import classNames from 'classnames/bind';

import If from '@components/shared/conditional/If/If';
import SelectedIndicator from '../modals/CreateProjectModal/SelectedIndicator/index';
import styles from './ChoiceBubble.module.scss';

const cx = classNames.bind(styles);

const ChoiceBubble = ({
  isSelected,
  onClick,
  choice,
  classes,
}: any) => {
  const handleClick = () => {
    if (choice.disabled) return null;

    return onClick(choice);
  };

  return (
    <button
      className={ cx({
        isSelected: isSelected && !choice.disabled,
        isDisabled: choice.disabled,
        Root: true,
        [classes.Button]: !!classes.Button,
        [classes.isButtonSelected]: !!classes.Button && isSelected && !choice.disabled,
      }) }
      onClick={ handleClick }
      type="button"
    >
      <If condition={ choice.icon }>
        <div className={ `${styles.ImagesWrapper} ${classes.ImagesWrapper}` }>
          <div
            className={ styles.ImageWrapper }
            dangerouslySetInnerHTML={{ __html: choice.icon }}
          />
        </div>
      </If>

      <If condition={ choice.iconUrl }>
        <div className={ `${styles.ImagesWrapper} ${classes.ImagesWrapper}` }>
          <img
            alt=""
            className={ styles.ImageWrapper }
            src={ choice.iconUrl }
          />
        </div>
      </If>

      <If condition={ choice.title !== null }>
        <h3 className={ `${styles.Title} ${classes.Title}` }>{ choice.title }</h3>
      </If>

      <SelectedIndicator
        className={ classes.SelectedIndicator }
        isVisible={ (isSelected && !choice.disabled) }
      />
    </button>
  );
};

export default ChoiceBubble;
